var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BookingBack',{attrs:{"title":"Gift Card","textColor":'#333333',"isCenter":true}}),_c('div',{staticClass:"cards"},_vm._l((_vm.cardList),function(item){return _c('div',{key:item.id},[_c('GiftCardPreview',{attrs:{"cardData":item}})],1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }